import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Ajax from '../../lib/ajax';

interface SoLinePickListState extends ListState<any> {
	soLineInfo:any;
}
class SoLinePickListModule extends ListModule<SoLinePickListState, any, any> {
	state = {
		totalCount: 0,
		currentPage: 1,
		pageSize: 10,
		list: new Array<any>(),
		loading: false,
		soLineInfo: null,
	};
	actions = {
		async getAll(context: ActionContext<SoLinePickListState, any>, payload: any) {
            context.state.loading = true;
            const {data:{result} }= await Ajax.get('/api/services/app/SoLine/all-pick-list', { params: payload.data });
            context.state.loading = false;
            const page = result ;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
			context.state.soLineInfo = page.soLineInfo;
			return  page.items;
        },
		async adjustConfirmPickingQty(context: ActionContext<SoLinePickListState, any>, payload: any) {
            await Ajax.put('/api/services/app/SoLine/AdjustConfirmPickingQty', payload.data);
        },
		async adjustConfirmPackingQty(context: ActionContext<SoLinePickListState, any>, payload: any) {
            await Ajax.put('/api/services/app/SoLine/AdjustConfirmPackingQty', payload.data);
        },
	};
	mutations = {
		setCurrentPage(state: SoLinePickListState, page: number) {
			state.currentPage = page;
		},
		setPageSize(state: SoLinePickListState, pagesize: number) {
			state.pageSize = pagesize;
		},
		refreshListData(state: SoLinePickListState)
        {
            state.list = new Array<any>();
        },
		resetSoLineInfoData(state: SoLinePickListState)
        {
            state.soLineInfo = null;
        },
	};
}
const pickListModule = new SoLinePickListModule();
export default pickListModule;
